
export class Rol {
  id: number;
  nombre: String;
  constructor() {

  }

}